import { render, staticRenderFns } from "./TransferReport.template.vue?vue&type=template&id=720df97a&scoped=true&"
var script = {}
import style0 from "./TransferReport.template.vue?vue&type=style&index=0&id=720df97a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720df97a",
  null
  
)

export default component.exports